export const KeyEnum = {
  Platform: {
    ANDROID: '1',
    IOS: '2',
    ARM_LINUX: '4',
    X86_LINUX: '8',
    WINDOWS: '16',
    PLAT_YTBOX: '32',
    PLAT_SERVER: '64'
  },
  ApplyPlatform: {
    WEB: '1',
    IOS: '2',
    ANDROID: '4',
    OTHERS: '8'
  },
  PrivateServiceType: {
    SKYEYE: 1,
    TRAFFIC: 2,
    FACEIN: 4
  },
// 平台产品（由 人体类服务 改名）
// SVAP应用（由 车辆类服务 改名）
// 人脸类服务
// OCR类服务
// 其他服务（由 其他 改名，原车辆类服务、人体类服务都并入这里，通过数据库修改类别的方式）
  PrivateGroup: [{
    value: 'BODY',
    label: '平台产品'
  }, {
    value: 'CAR',
    label: 'SVAP应用'
  }, {
    value: 'FACE',
    label: '人脸类服务'
  // }, {
  //   value: 'BODY',
  //   label: '人体类服务'
  // }, {
  //   value: 'CAR',
  //   label: '车辆类服务'
  }, {
    value: 'OCR',
    label: 'OCR类服务'
  }, {
    value: 'OTHER',
    label: '其他服务'
  }],
  SdkGroupType: [{
    value: 'sdk/app/android',
    label: 'Android SDK',
    platform: '1'
  }, {
    value: 'sdk/app/ios',
    label: 'iOS SDK',
    platform: '2'
  }, {
    value: 'sdk/device/android',
    label: 'Android SDK',
    platform: '1'
  }, {
    value: 'sdk/device/linux',
    label: '其他',
    platform: '8'
  }],
  UsageType: {
    ENTERTAINMENT: 1,
    GAME: 2,
    SECURITY: 64,
    FINANCE: 128,
    TOOL: 4,
    GOVERMENT: 256,
    SOCIAL: 16,
    OTHERS: 32
  },
  AuthType: {
    DEVICE: 1,
    CENTER: 2
  },
  LimitType: {
    QPS: 1,
    DOCKER: 2,
    PHYSICAL: 3,
    GPU: 4,
    SKU: 5
  },
  MachineType: {
    PHYSICAL: 1,
    VIRTUAL: 2
  },
  JoinWay: {
    EXTERNAL: 0x1,
    INTERNAL: 0x2
  },
  AppApplyStatus: {
    // VERIFYING: 0x1,
    // VERIFY_SUCCESS: 0x2,
    // VERIFY_FAIL: 0x4,
    // AUTH_OVER: 0x8,
    FORMAL_VERIFYING: 0x100,
    FORMAL_VERIFY_SUCCESS: 0x200,
    FORMAL_VERIFY_FAIL: 0x400,
    STOP: 0x4000,
    DELETED: 0x8000
  },
  SdkApplyStatus: {
    VERIFYING: 0x1,
    VERIFY_SUCCESS: 0x2,
    VERIFY_FAIL: 0x4,
    AUTH_OVER: 0x8,
    FORMAL_VERIFYING: 0x100,
    FORMAL_VERIFY_SUCCESS: 0x200,
    FORMAL_VERIFY_FAIL: 0x400,
    FORMAL_AUTH_OVER: 0x800,
    STOP: 0x4000,
    DELETED: 0x8000
  },
  PrivateApplyStatus: {
    VERIFYING: 0x1,
    VERIFY_SUCCESS: 0x2,
    VERIFY_FAIL: 0x4,
    AUTH_OVER: 0x8,
    FORMAL_VERIFYING: 0x100,
    FORMAL_VERIFY_SUCCESS: 0x200,
    FORMAL_VERIFY_FAIL: 0x400,
    FORMAL_AUTH_OVER: 0x800,
    DELETED: 0x8000
  },
  YtboxApplyStatus: {
    VERIFYING: 0x1,
    VERIFY_SUCCESS: 0x2,
    VERIFY_FAIL: 0x4,
    AUTH_OVER: 0x8,
    FORMAL_VERIFYING: 0x100,
    FORMAL_VERIFY_SUCCESS: 0x200,
    FORMAL_VERIFY_FAIL: 0x400,
    FORMAL_AUTH_OVER: 0x800,
    DELETED: 0x8000,
    STOP: 0x4000
  },
  YtcommonApplyStatus: {
    VERIFYING: 0x1,
    VERIFY_SUCCESS: 0x2,
    VERIFY_FAIL: 0x4,
    AUTH_OVER: 0x8,
    FORMAL_VERIFYING: 0x100,
    FORMAL_VERIFY_SUCCESS: 0x200,
    FORMAL_VERIFY_FAIL: 0x400,
    FORMAL_AUTH_OVER: 0x800,
    STOP: 0X4000,
    DELETED: 0x8000
  },
  SdkApplyType: {
    TEST: 1,
    FORMAL: 2,
    ALL: null
  },
  PrivateApplyType: {
    TEST: '1',
    FORMAL: '2',
    ALL: null
  },
  YtboxApplyType: {
    TEST: '1',
    FORMAL: '2',
    ALL: null
  },
  AppApplyType: {
    TEST: '1',
    FORMAL: '2',
    ALL: null
  },
  SdkBindType: {
    APP: '1',
    DEVICE: '2'
  },
  SdkServiceType: {
    BUSINESS: 1,
    GOVERMENT: 2,
    OTHER: 3
  },
  JoinType: {
    CLOUD_SERVICE: 1,
    FACEIN_SERVICE: 2,
    OFFLINE_SDK: 4,
    FACE_MERGE: 8
  },
  DeviceAuth: {
    ADD: 0,
    ACTIVE: 1,
    AUTH: 16
  }
};
const appKeyEnum = KeyEnum.AppApplyStatus;
const sdkKeyEnum = KeyEnum.SdkApplyStatus;
const privateKeyEnum = KeyEnum.PrivateApplyStatus;
const ytboxKeyEnum = KeyEnum.YtboxApplyStatus;
const ytcommonKeyEnum = KeyEnum.YtcommonApplyStatus;
const platformKeyEnum = KeyEnum.Platform;
export const OptionMapper = {
  JOIN_WAY: [{
    value: KeyEnum.JoinWay.EXTERNAL,
    label: '外部接入'
  }, {
    value: KeyEnum.JoinWay.INTERNAL,
    label: '内部接入'
  }],
  APPLY_PLATFORM: [{
    value: KeyEnum.ApplyPlatform.WEB,
    label: 'Web'
  }, {
    value: KeyEnum.ApplyPlatform.IOS,
    label: 'iOS'
  }, {
    value: KeyEnum.ApplyPlatform.ANDROID,
    label: 'Android'
  }, {
    value: KeyEnum.ApplyPlatform.OTHERS,
    label: '其他'
  }],
  USAGE_TYPE: [{
    value: KeyEnum.UsageType.ENTERTAINMENT,
    label: '娱乐'
  }, {
    value: KeyEnum.UsageType.GAME,
    label: '游戏'
  }, {
    value: KeyEnum.UsageType.SECURITY,
    label: '安防'
  }, {
    value: KeyEnum.UsageType.FINANCE,
    label: '金融'
  }, {
    value: KeyEnum.UsageType.TOOL,
    label: '工具'
  }, {
    value: KeyEnum.UsageType.GOVERMENT,
    label: '政务'
  }, {
    value: KeyEnum.UsageType.SOCIAL,
    label: '社交'
  }, {
    value: KeyEnum.UsageType.OTHERS,
    label: '其他'
  }],
  MAINSTAY_TYPE: [{
    value: KeyEnum.JoinWay.INTERNAL,
    label: '腾讯内部业务'
  }, {
    value: KeyEnum.JoinWay.EXTERNAL,
    label: '腾讯外部业务'
  }],
  JOIN_TYPE: [{
    value: KeyEnum.JoinType.CLOUD_SERVICE,
    label: '云服务'
  }, {
    value: KeyEnum.JoinType.FACEIN_SERVICE,
    label: 'FaceIn人脸服务'
  }, {
    value: KeyEnum.JoinType.OFFLINE_SDK,
    label: '离线SDK'
  }],
  JOIN_TYPE_EXTERNAL: [{
    value: KeyEnum.JoinType.CLOUD_SERVICE,
    label: '云服务'
  }, {
    value: KeyEnum.JoinType.FACEIN_SERVICE,
    label: 'FaceIn人脸服务'
  }, {
    value: KeyEnum.JoinType.OFFLINE_SDK,
    label: '离线SDK'
  }, {
    value: KeyEnum.JoinType.FACE_MERGE,
    label: '人脸融合'
  }],
  BIND_TYPE: [{
    value: KeyEnum.SdkBindType.APP,
    label: '绑定APP'
  }, {
    value: KeyEnum.SdkBindType.DEVICE,
    label: '绑定设备'
  }],
  SDK_APPLY_TYPE: [{
    value: KeyEnum.SdkApplyType.TEST,
    label: '测试'
  }, {
    value: KeyEnum.SdkApplyType.FORMAL,
    label: '正式'
  }, {
    value: KeyEnum.SdkApplyType.ALL,
    label: '所有 (正式和测试)'
  }],
  APP_APPLY_TYPE: [{
    value: KeyEnum.AppApplyType.TEST,
    label: '测试'
  }, {
    value: KeyEnum.AppApplyType.FORMAL,
    label: '正式'
  }, {
    value: KeyEnum.AppApplyType.ALL,
    label: '所有 (正式和测试)'
  }],
  PRIVATE_APPLY_TYPE: [{
    value: KeyEnum.AppApplyType.TEST,
    label: '测试'
  }, {
    value: KeyEnum.AppApplyType.FORMAL,
    label: '正式'
  }, {
    value: KeyEnum.AppApplyType.ALL,
    label: '所有 (正式和测试)'
  }],
  SDK_APPLY_STATUS: [{
    value: sdkKeyEnum.VERIFYING,
    label: '待审核'
  }, {
    value: sdkKeyEnum.VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: sdkKeyEnum.VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: sdkKeyEnum.AUTH_OVER,
    label: '测试期结束'
  }, {
    value: sdkKeyEnum.FORMAL_VERIFYING,
    label: '待审核'
  }, {
    value: sdkKeyEnum.FORMAL_VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: sdkKeyEnum.FORMAL_VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: sdkKeyEnum.FORMAL_AUTH_OVER,
    label: '授权结束'
  }, {
    value: sdkKeyEnum.STOP,
    label: '已停用'
  }, {
    value: sdkKeyEnum.DELETED,
    label: '已删除'
  }],
  APP_APPLY_STATUS: [{
  //   value: appKeyEnum.VERIFYING,
  //   label: '待审核'
  // }, {
  //   value: appKeyEnum.VERIFY_SUCCESS,
  //   label: '审核通过'
  // }, {
  //   value: appKeyEnum.VERIFY_FAIL,
  //   label: '审核失败'
  // }, {
  //   value: appKeyEnum.AUTH_OVER,
  //   label: '测试期结束'
  // }, {
    value: appKeyEnum.FORMAL_VERIFYING,
    label: '待审核'
  }, {
    value: appKeyEnum.FORMAL_VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: appKeyEnum.FORMAL_VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: appKeyEnum.STOP,
    label: '禁用'
  }, {
    value: appKeyEnum.DELETED,
    label: '已删除'
  }],
  PRIVATE_APPLY_STATUS: [{
    value: privateKeyEnum.VERIFYING,
    label: '待审核'
  }, {
    value: privateKeyEnum.VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: privateKeyEnum.VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: privateKeyEnum.AUTH_OVER,
    label: '测试期结束'
  }, {
    value: privateKeyEnum.FORMAL_VERIFYING,
    label: '待审核'
  }, {
    value: privateKeyEnum.FORMAL_VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: privateKeyEnum.FORMAL_VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: privateKeyEnum.FORMAL_AUTH_OVER,
    label: '授权结束'
  }, {
    value: privateKeyEnum.DELETED,
    label: '已删除'
  }],
  YOUTUBOX_APPLY_STATUS: [{
    value: ytboxKeyEnum.VERIFYING,
    label: '待审核'
  }, {
    value: ytboxKeyEnum.VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: ytboxKeyEnum.VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: ytboxKeyEnum.AUTH_OVER,
    label: '测试期结束'
  }, {
    value: ytboxKeyEnum.FORMAL_VERIFYING,
    label: '待审核'
  }, {
    value: ytboxKeyEnum.FORMAL_VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: ytboxKeyEnum.FORMAL_VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: ytboxKeyEnum.FORMAL_AUTH_OVER,
    label: '授权结束'
  }, {
    value: ytboxKeyEnum.DELETED,
    label: '已删除'
  }],
  COMMON_APPLY_STATUS: [{
    value: ytcommonKeyEnum.VERIFYING,
    label: '待审核'
  }, {
    value: ytcommonKeyEnum.VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: ytcommonKeyEnum.VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: ytcommonKeyEnum.AUTH_OVER,
    label: '测试期结束'
  }, {
    value: ytcommonKeyEnum.FORMAL_VERIFYING,
    label: '待审核'
  }, {
    value: ytcommonKeyEnum.FORMAL_VERIFY_SUCCESS,
    label: '审核通过'
  }, {
    value: ytcommonKeyEnum.FORMAL_VERIFY_FAIL,
    label: '审核失败'
  }, {
    value: ytcommonKeyEnum.FORMAL_AUTH_OVER,
    label: '授权结束'
  }, {
    value: ytcommonKeyEnum.STOP,
    label: '已停用'
  }, {
    value: ytcommonKeyEnum.DELETED,
    label: '已删除'
  }],
  PLATFORM_TYPE: [{
    value: platformKeyEnum.ANDROID,
    label: 'Android'
  }, {
    value: platformKeyEnum.IOS,
    label: 'iOS'
  }, {
    value: platformKeyEnum.X86_LINUX,
    label: 'x86 Linux'
  }, {
    value: platformKeyEnum.ARM_LINUX,
    label: 'arm Linux'
  }, {
    value: platformKeyEnum.WINDOWS,
    label: 'Windows'
  }],
  PRIVATE_BUSINESS_TYPE: [{
    value: 1 << 0,
    label: '天眼安防'
  }, {
    value: 1 << 1,
    label: '天眼交通'
  }, {
    value: 1 << 2,
    label: 'FaceIn人脸核身'
  }],
  AUTH_TYPE: [{
    value: KeyEnum.AuthType.DEVICE,
    label: '绑定设备'
  }, {
    value: KeyEnum.AuthType.CENTER,
    label: '中心授权'

  }],
  LIMIT_TYPE: [{
    value: KeyEnum.LimitType.QPS,
    label: '限制QPS'
  }, {
    value: KeyEnum.LimitType.DOCKER,
    label: '限制容器数量'
  }, {
    value: KeyEnum.LimitType.PHYSICAL,
    label: '限制物理机数量'
  }, {
    value: KeyEnum.LimitType.GPU,
    label: '限制卡数量'
  }, {
    value: KeyEnum.LimitType.SKU,
    label: '限制产品/应用/服务数量'
  }],
  MECHINE_TYPE: [{
    value: KeyEnum.MachineType.PHYSICAL,
    label: '物理机'
  }, {
    value: KeyEnum.MachineType.VIRTUAL,
    label: '虚拟机'

  }],
  SDK_TYPE: [{
    value: 1 << 0,
    label: '人脸检测配准SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 1,
    label: '人脸聚类SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 2,
    label: '动效SDK',
    platform: KeyEnum.Platform.ANDROID,
    downloadDisable: true
  }, {
    value: 1 << 3,
    label: '人脸提特征SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 4,
    label: '1:N人脸比对SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 5,
    label: '人脸跟踪优选SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 6,
    label: '防翻拍活体SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 7,
    label: '摇头眨眼活体SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 8,
    label: '反光活体SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 9,
    label: '3D活体SDK',
    platform: KeyEnum.Platform.ANDROID
  }, {
    value: 1 << 10,
    label: '人脸检测配准SDK',
    platform: KeyEnum.Platform.IOS
  }, {
    value: 1 << 11,
    label: '人脸聚类SDK',
    platform: KeyEnum.Platform.IOS
  }, {
    value: 1 << 12,
    label: '动效SDK',
    platform: KeyEnum.Platform.IOS,
    downloadDisable: true
  }, {
    value: 1 << 13,
    label: '人脸提特征SDK',
    platform: KeyEnum.Platform.IOS
  }, {
    value: 1 << 14,
    label: '摇头眨眼活体SDK',
    platform: KeyEnum.Platform.IOS
  }, {
    value: 1 << 15,
    label: '反光活体SDK',
    platform: KeyEnum.Platform.IOS
  }, {
    value: 1 << 16,
    label: '人脸检测配准SDK',
    platform: KeyEnum.Platform.X86_LINUX
  }, {
    value: 1 << 17,
    label: '人脸提特征SDK',
    platform: KeyEnum.Platform.X86_LINUX
  }, {
    value: 1 << 18,
    label: '1:N人脸比对SDK',
    platform: KeyEnum.Platform.X86_LINUX
  }, {
    value: 1 << 19,
    label: '人脸跟踪优选SDK',
    platform: KeyEnum.Platform.X86_LINUX
  }, {
    value: 1 << 20,
    label: '人脸属性SDK',
    platform: KeyEnum.Platform.X86_LINUX
  }, {
    value: 1 << 21,
    label: '3D活体SDK',
    platform: KeyEnum.Platform.X86_LINUX
  }, {
    value: 1 << 22,
    label: '人脸检测配准SDK',
    platform: KeyEnum.Platform.ARM_LINUX
  }, {
    value: 1 << 23,
    label: '人脸提特征SDK',
    platform: KeyEnum.Platform.ARM_LINUX
  }, {
    value: 1 << 24,
    label: '人脸跟踪优选SDK',
    platform: KeyEnum.Platform.ARM_LINUX
  }, {
    value: 1 << 25,
    label: '人脸检测配准SDK',
    platform: KeyEnum.Platform.WINDOWS
  }, {
    value: 1 << 26,
    label: '人脸提特征SDK',
    platform: KeyEnum.Platform.WINDOWS
  }, {
    value: 1 << 27,
    label: '人脸跟踪优选SDK',
    platform: KeyEnum.Platform.WINDOWS
  }, {
    value: 1 << 28,
    label: '防翻拍活体SDK',
    platform: KeyEnum.Platform.WINDOWS
  }, {
    value: 1 << 29,
    label: '3D活体SDK',
    platform: KeyEnum.Platform.WINDOWS
  }],
  DEVICE_AUTH_INFO: [{
    value: 1,
    label: 'add'
  }, {
    value: 2,
    label: 'active'
  }, {
    value: 16,
    label: 'auth'
  }],
  SDK_SERVICE_TYPE: [{
    value: KeyEnum.SdkServiceType.BUSINESS,
    label: '商业应用'
  }, {
    value: KeyEnum.SdkServiceType.GOVERMENT,
    label: '政府业务'
  }, {
    value: KeyEnum.SdkServiceType.OTHER,
    label: '其他'
  }],
  PRIVATE_SERVICE_TYPE: [{
    value: KeyEnum.PrivateServiceType.SKYEYE,
    label: '天眼安防'
  }, {
    value: KeyEnum.PrivateServiceType.TRAFFIC,
    label: '天眼交通'
  }, {
    value: KeyEnum.PrivateServiceType.FACEIN,
    label: 'FaceIn人脸核身'
  }],
  BUSINESS_DEPARTMENT: [{
    value: 1,
    label: 'CSIG/云行业一部'
  }, {
    value: 2,
    label: 'CSIG/云行业二部'
  }, {
    value: 3,
    label: 'CSIG/云行业三部'
  }, {
    value: 4,
    label: 'CSIG/云行业四部'
  }, {
    value: 5,
    label: 'CSIG/云AI及大数据产品中心'
  }, {
    value: 12,
    label: 'CSIG/云视频产品中心'
  }, {
    value: 6,
    label: 'CSIG/云文化旅游中心'
  }, {
    value: 7,
    label: 'CSIG/云云业务安全中心（天御）'
  }, {
    value: 13,
    label: 'CSIG/优图实验室'
  }, {
    value: 8,
    label: 'CDG/公共业务合作中心'
  }, {
    value: 9,
    label: 'PCG/智慧项目中心'
  }, {
    value: 10,
    label: 'WXG/微信支付-行业应用中心'
  }, {
    value: 11,
    label: '其他'
  }]
};

export const DisplayMapper = {};
function mapToDisplay(key, keyPairs, formatLabelFn) {
  let mapper = DisplayMapper[key] = {};
  for (let i = 0; i < keyPairs.length; i++) {
    let keyPair = keyPairs[i];
    let label = formatLabelFn ? formatLabelFn(keyPair) : keyPair.label;
    mapper[keyPair.value] = label;
  }
}
function mapFunctionToDisplay(key, keyPairs) {
  DisplayMapper[key] = function(value) {
    value = parseInt(value);
    let display = '';
    for (let i = 0; i < keyPairs.length; i++) {
      let keyPair = keyPairs[i];
      if ((parseInt(keyPair.value) & value) === 0) {
        continue;
      }
      if (display.length !== 0) {
        display += ', ';
      }
      display += keyPair.label;
    }
    return display;
  };
}

mapToDisplay('SDK_APPLY_TYPE', OptionMapper.SDK_APPLY_TYPE);
mapToDisplay('APP_APPLY_TYPE', OptionMapper.APP_APPLY_TYPE);
mapToDisplay('PRIVATE_APPLY_TYPE', OptionMapper.PRIVATE_APPLY_TYPE);
mapToDisplay('SDK_APPLY_STATUS', OptionMapper.SDK_APPLY_STATUS);
mapToDisplay('APP_APPLY_STATUS', OptionMapper.APP_APPLY_STATUS);
mapToDisplay('PRIVATE_APPLY_STATUS', OptionMapper.PRIVATE_APPLY_STATUS);
mapToDisplay('YOUTUBOX_APPLY_STATUS', OptionMapper.YOUTUBOX_APPLY_STATUS);
mapToDisplay('COMMON_APPLY_STATUS', OptionMapper.COMMON_APPLY_STATUS);
mapToDisplay('PLATFORM_TYPE', OptionMapper.PLATFORM_TYPE);
mapToDisplay('DEVICE_AUTH_INFO', OptionMapper.DEVICE_AUTH_INFO);
mapToDisplay('USAGE_TYPE', OptionMapper.USAGE_TYPE);
mapToDisplay('BIND_TYPE', OptionMapper.BIND_TYPE);
mapToDisplay('SDK_TYPE', OptionMapper.SDK_TYPE);
mapToDisplay('SDK_SERVICE_TYPE', OptionMapper.SDK_SERVICE_TYPE);
mapToDisplay('PRIVATE_BUSINESS_TYPE', OptionMapper.PRIVATE_BUSINESS_TYPE);
mapToDisplay('PRIVATE_SERVICE_TYPE', OptionMapper.PRIVATE_SERVICE_TYPE);
mapToDisplay('AUTH_TYPE', OptionMapper.AUTH_TYPE);
mapToDisplay('MECHINE_TYPE', OptionMapper.MECHINE_TYPE);
mapToDisplay('SDK_PLATFORM_TYPE', OptionMapper.SDK_TYPE, function(keyPair) {
  return `${keyPair.label}(${DisplayMapper.PLATFORM_TYPE[keyPair.platform]})`;
});
mapToDisplay('SDK_ORIGIN_INFO', OptionMapper.SDK_TYPE, function(keyPair) {
  return keyPair;
});
mapFunctionToDisplay('APPLY_PLATFORM', OptionMapper.APPLY_PLATFORM);
mapFunctionToDisplay('MAINSTAY_TYPE', OptionMapper.MAINSTAY_TYPE);
mapFunctionToDisplay('JOIN_TYPE', OptionMapper.JOIN_TYPE);
mapFunctionToDisplay('JOIN_TYPE_EXTERNAL', OptionMapper.JOIN_TYPE_EXTERNAL);



// WEBPACK FOOTER //
// ./src/common/OptionConstant.js